module.exports = __webpack_public_path__ + "static/media/class.64ee19d8.svg";